import React from 'react';
import XSmall from '@uber/base-icons/x-small';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { PLACEMENT, Popover } from 'baseui/popover';
import { LabelSmall } from 'baseui/typography';
import { ActionSection, PopoverContent } from './styled-components-overrides';
export const ActionSectionComponent = ({
  disabled,
  onEvaluate
}: {
  disabled: boolean;
  onEvaluate: () => Promise<void>;
}) => {
  const [, theme] = useStyletron();
  const [togglePopover, setTogglePopover] = React.useState(!disabled);
  const handleEvaluate = async () => {
    await onEvaluate();
    setTogglePopover(false);
  };
  return <ActionSection>
      <Popover isOpen={togglePopover} popoverMargin={15} content={() => <PopoverContent>
            <LabelSmall color={theme.colors.contentInversePrimary} margin={0}>
              Click evaluate to check your content for errors
            </LabelSmall>
            <XSmall size={30} onClick={() => setTogglePopover(false)} />
          </PopoverContent>} placement={PLACEMENT.top} showArrow overrides={{
      Arrow: {
        style: ({
          $theme
        }) => ({
          outlineColor: $theme.colors.backgroundInverseSecondary,
          backgroundColor: $theme.colors.backgroundInverseSecondary
        })
      }
    }}>
        {/* Wrapping Button in div to create a stable DOM structure that prevents Popover from capturing and interfering with Button's click events */}
        <div>
          <Button onClick={handleEvaluate} disabled={disabled} overrides={{
          BaseButton: {
            style: {
              width: '100%'
            }
          }
        }}>
            Evaluate
          </Button>
        </div>
      </Popover>
    </ActionSection>;
};